import { LoadState } from "../../constants/enums";

export interface ICommAutoDriverProfile {
  customer_policy_id: number;
  incremental_number: number | null;
  customer_id: number;
  broker_name: string | null;
  broker_code: string | null;
  producer_name: string | null;
  producer_code: string | null;
  producer_id: string | null;
  applicant_name: string | null;
  policy_number: string | null;
  driver_name: string | null;
  driver_license_number: string | null;
  current_license_class: string | null;
  date_of_birth: string | null;
  date_of_receipt: string | null;
  first_license_date: string | null;
  years_current_license: number | null;
  years_driving_usa: number | null;
  is_owner_operator: boolean;
  is_contractor_operator: boolean;
  is_company_driver: boolean;
  prior_experience: IPriorExperience[] | null;
  employer_information: IEmployerInformation[] | null;
  driver_training: IDriverTraining[] | null;
  previous_accidents: IPreviousAccident[] | null;
  additional_comments: string | null;
  status: string;
}

export interface IPriorExperience {
  effective_date: string | null;
  expiry_date: string | null;
  policy_number: string | null;
  insurance_company: string | null;
}

export interface IEmployerInformation {
  company_name: string | null;
  type_of_vehicles_driven: string | null;
  address: string | null;
  supervisor_name: string | null;
  phone: string | null;
  start_date: string | null;
  end_date: string | null;
  comments: string | null;
  is_current: boolean;
}

export interface IDriverTraining {
  training_name: string | null;
  year: string | null;
}

export interface IPreviousAccident {
  date: string | null;
  type_of_loss: string | null;
  amount_paid: string | null;
  location: string | null;
  details: string | null;
}

export interface ICommAutoDriverProfileState {
  list: ICommAutoDriverProfile[];
  totalRecords: number;
  loading: LoadState;
  driverProfile: ICommAutoDriverProfile;
  driverProfileLoading: LoadState;
  saveLoading: boolean;
}

export const initialCommAutoDriverProfile: ICommAutoDriverProfile = {
  customer_policy_id: 0,
  incremental_number: null,
  customer_id: 0,
  broker_name: null,
  broker_code: null,
  producer_name: null,
  producer_code: null,
  producer_id: null,
  applicant_name: null,
  policy_number: null,
  driver_name: null,
  driver_license_number: null,
  current_license_class: null,
  date_of_birth: null,
  date_of_receipt: null,
  first_license_date: null,
  years_current_license: null,
  years_driving_usa: null,
  is_owner_operator: false,
  is_contractor_operator: false,
  is_company_driver: false,
  prior_experience: null,
  employer_information: null,
  driver_training: null,
  previous_accidents: null,
  additional_comments: null,
  status: "ACTIVE",
};

export const initialCommAutoDriverProfileState: ICommAutoDriverProfileState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
  driverProfile: initialCommAutoDriverProfile,
  driverProfileLoading: LoadState.NotLoaded,
  saveLoading: false,
};
